export const getErrorMessage = (errorResponse, errorMessage) => {
    const errorStatusCode = errorResponse?.status;
    switch (errorStatusCode) {
        case 400:
            return 'Bad Request. Please check your input.';
        case 401:
            return 'Unauthorized. Please log in.';
        case 403:
            return 'Forbidden. You do not have permission to access this resource.';
        case 404:
            return 'Not Found. The requested resource could not be found.';
        case 422:
            return 'Unprocessable Entity. The request was well-formed but was unable to be followed due to semantic errors.';
        case 500:
            return 'Internal Server Error. Please try again later.';
        case 502:
            return 'Bad Gateway. Please try again later.';
        default:
            return errorMessage;
    }
};